import type React from 'react';

export interface CollaboratorPresence {
  readonly id: string;
  readonly displayName: string;
  readonly color: string;
}

interface Props {
  collaborators: readonly CollaboratorPresence[];
}

export function CollaboratorPresence({ collaborators }: Props): React.ReactElement | null {
  if (collaborators.length === 0) return null;
  return (
    <div
      className="flex gap-x-1"
      aria-label={`${collaborators.length} active collaborator${collaborators.length === 1 ? '' : 's'}`}
      data-testid="collab-presence"
    >
      {collaborators.map(c => (
        <span
          key={c.id}
          title={c.displayName}
          className="inline-flex size-6 items-center justify-center rounded-full border border-border text-xs font-semibold"
          style={{ backgroundColor: c.color }}
        >
          {c.displayName.charAt(0).toUpperCase()}
        </span>
      ))}
    </div>
  );
}
